<template>
    <div>
        <!-- header section -->
        <section class="header-section">
            <div class="container h-100">
                <div class="h-100 d-flex">
                    <div class="col-lg-6 col-12 h-100">
                        <!-- slider-1 -->
                        <div class="content-block-top col-12">
							<hooper
								v-if="showSliders"
								:rtl="$i18n.locale === 'ar'"
								:autoPlay="true"
								:playSpeed="5000"
								group="group-1"
								style="height: 100%"
								:infiniteScroll="true"
								:wheelControl="false"
							>
								<slide v-for="item in sliders" :key="item.id" class="slider-font-size">
									<span class="px-4">
										{{item.description}}
									</span>
								</slide>
								<hooper-pagination slot="hooper-addons"></hooper-pagination>
							</hooper>
						</div>

                        <!-- buttons -->
                        <div class="content-block-bottom col-12">
                            <div class="block-width">
                                <div class="block-width-wrapper d-flex justify-content-between pt-4 mx-auto mx-lg-2">
                                    <router-link to="/all-products" class="button first-button button-1">{{ $t('homepage.header-section.buttons.browse-our-products') }}</router-link>
                                    <router-link to="/contact-us" class="button second-button button-2">{{ $t('homepage.header-section.buttons.contact-us') }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- slider-2 -->
                    <div class="col-lg-6 d-none d-lg-block h-80">
						<hooper
							v-if="showSliders"
							:rtl="$i18n.locale === 'ar'"
							:autoPlay="true"
							:playSpeed="5000"
							group="group-1"
							style="height: 100%"
							:infiniteScroll="true"
							:wheelControl="false"
						>
							<slide v-for="item in sliders" :key="item.id">
								<img :src="item.image" alt="" width="450">
							</slide>
						</hooper>
					</div>
                </div>
            </div>
        </section>

        <!-- about section -->
        <section class="about-section">
            <div class="container h-100">
                <div class="w-100 h-100 row mx-auto pt-4 pt-xl-5">
                    <div class="col-lg-8 col-12">
                        <div class="d-flex flex-column h-100 about-content">
                            <div>
                                <h5 class="about-content-title bold mb-4" v-html="$t('homepage.about-section.title')"></h5>
								<p class="mb-4" v-html="about?.find(c => c.key === 'about' && c.id === 1)?.value"></p>

                                <div class="tall-button first-button mx-auto mx-lg-0 d-flex pointer" @click="downloadFile()">
                                    <img src="@/assets/images/down-to-line.png" alt="" width="20" class="px-1">
                                    <span class="px-1 bold">
                                        {{ $t('homepage.about-section.button') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 px-0 my-auto">
                        <div class="about-image">
							<div v-if="true" class="d-flex justify-content-center">
								<img src="@/assets/images/screw-buildings.jpg" alt="img" class="image-class rounded-4">
							</div>
							<div v-else-if="false">
								<img :src="albums[0]?.primaryImage?.url" alt="img" class="image-class rounded-4">
								<!-- <video
									controls
									loop
									autoplay
								>
									<source :src="BYTE_RANGE_URL + '/' + videoId">
								</video> -->
							</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- categories section -->
        <section class="categories-section mb-4 pb-2">
            <div class="container h-100">
                <div class="w-100 text-center py-4">
                    <h4 class="section-title" v-html="$t('homepage.categories-section.title')"></h4>
                </div>
                <div v-if="categories.length > 0" class="w-100 d-flex flex-wrap pt-4">
                    <div
						v-for="item in categories.slice(0, 6)"
						:key="item.id"
						class="categories-card-block"
                    >
						<router-link
							:to="{ name: 'category', params: { slug: item.slug } }"
							class="d-flex flex-column flex-md-row p-4 rounded-4 bg-white card-shadow router-link-class category-router-link h-100"
						>
							<div class="categories-card-content order-last order-md-first">
								<h5 class="bold mb-3 v-html-card-header">{{ item.name }}</h5>
								<p class="mb-0 v-html-card-description" v-html="item.summary || item.description"></p>
							</div>
							<div class="categories-card-image order-first order-md-last d-flex align-items-center">
								<img :src="item.image" alt="" class="w-100 pb-4 pb-md-0">
							</div>
                        </router-link>
                    </div>
                </div>
				<!-- more categories button -->
				<router-link v-if="categories.length > 9" to="/all-categories" class="button first-button tall-button mx-auto mt-2">
					{{$t('homepage.categories-section.button')}}
				</router-link>
            </div>
        </section>

        <!-- products section -->
        <section class="products-section pb-5 mb-3">
			<div class="container h-100">
				<div class="w-100 text-center pt-4">
                    <h4 class="section-title" v-html="$t('homepage.products-section.title')"></h4>
                </div>

				<!-- tabs -->
				<div class="d-flex flex-wrap justify-content-center mx-auto mt-4 mb-5">
					<ul v-for="item in tabs" :key="item.id" class="nav nav-pills mb-3" id="pills-tab" role="tablist">
						<li class="nav-item" role="presentation">
							<button
								:class="{'active': activeCategory === item.id}"
								class="nav-link"
								type="button"
								role="tab"
								@click="activeCategory = item.id"
							>
								{{item.name}}
							</button>
						</li>
					</ul>
				</div>

				<div v-if="currentProducts.length > 0" class="w-100 d-flex flex-wrap">
					<!-- products -->
					<router-link
						v-for="item in currentProducts.slice(0, 20)"
						:key="item.id"
						class="product-card-block mb-4 router-link-class"
						:to="{ name: 'product', params: { slug: item.slug } }"
                    >
                        <div class="px-4 pt-4 pb-3 rounded-top-4 bg-white card-shadow card-content-height">
							<!-- content -->
							<div class="d-flex flex-column justify-content-between text-center h-100">
								<div class="product-image pb-2">
									<img :src="item?.primaryImage.url" alt="" class="rounded-3" width="fit-content" height="100%">
								</div>
								<div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
									<div class="product-name bold h-100 d-flex align-items-center">
										{{item.name}}
									</div>
									<div class="product-attributes pt-2 d-flex justify-content-center">
										<div class="d-flex">
											<div v-if="item.attributes.some(c => c.type === 13)" class="d-flex align-items-center">
												<div class="d-flex align-items-center">
													<div
														v-for="(element, i) in filterAttributeValues(item.attributes.find(c => c.type === 13))"
														:key="i"
														:style="{ backgroundColor: element, width: '10px', height: '10px', borderRadius: '50%', margin: '0px 2px', border: '1px solid grey' }"
													>
													</div>
													<div v-if="item.attributes.find(c => c.type === 13)?.values.length > 4" style="margin: 0 2px">+</div>
												</div>
											</div>
										</div>
										<span v-if="item.attributes.length > 1" class="px-2 text-center" style="color: grey">|</span>
										<div class="d-flex justify-content-center">
											<div class="v-html-content content-elipse" v-html="item.attributes.find(c => c.type !== 13)?.value"></div>
											<img v-if="item.attributes.find(c => c.type !== 13)?.image?.url" :src="item.attributes[1]?.image?.url" alt="" class="px-1" width="25">
										</div>
									</div>
								</div>
							</div>
                        </div>
						<!-- eye -->
							<div class="w-100 rounded-bottom-4 text-center product-card-eye d-flex align-items-center justify-content-center">
								<i class="fa-solid fa-eye"></i>
							</div>
                    </router-link>
				</div>
				<div class="w-100 mt-4 pt-2">
					<router-link to="/all-products" class="tall-button first-button mx-auto mx-auto text-decoration-none ">
						<span class="px-1 bold">
							{{ $t('homepage.products-section.button') }}
						</span>
					</router-link>
				</div>
			</div>
		</section>

        <!-- contact section -->
        <section class="contact-section">
			<div class="container h-100">
				<div class="d-flex flex-column flex-lg-row h-100 mb-4">
					<div class="card-widths-1 h-100 d-flex justify-content-start align-items-center order-last order-lg-first">
						<!-- contact-us-form -->
						<div class="form-card-width rounded-4 card-shadow bg-white">
							<div class="contact-form-card p-5 px-5 pt-4 mt-2 pb-3">
								<!-- fix the font size -->
								<h5 class="contact-form-card-title section-title mb-4 pb-3" v-html="$t('contact-form.title')"></h5>
								<div class="my-3">
									<ContactForm :is-submitted="isFormSubmitted" @submitForm="submitForm" />
								</div>
							</div>
						</div>
					</div>
					<div class="card-widths-2 h-100 d-flex justify-content-center align-items-center order-first order-lg-last">
						<div class="py-4 h-90 w-100 d-flex flex-column align-items-center justify-content-center">
							<div class="h-50 w-100">
								<h4 class="section-title contact-info-title mb-3 mt-4 info-text-align" v-html="$t('homepage.contact-us-section.info-part.title')"></h4>
								<p class="contact-info-content mb-4 pb-2 info-text-align">{{ $t('homepage.contact-us-section.info-part.content') }}</p>
								<a
									:href="`https://wa.me/${contacts[0]?.whatsapp}`"
									target="_blank"
									class="button second-button tall-button mx-auto mx-md-0 text-decoration-none"
								>
									{{ $t('homepage.contact-us-section.info-part.button') }}
								</a>
							</div>
							<div class="w-100 my-3">
								<hr>
							</div>
							<div class="h-50 w-100">
								<div class="col-lg-4 col-md-4 col-12 mb-4 mb-lg-0 w-100">
									<h6 class="mb-4 d-flex justify-content-center justify-content-md-start bold other-info-title">
										{{ $t('homepage.contact-us-section.other-info.title') }}
									</h6>
									<div class="d-flex justify-content-center justify-content-md-start mb-4">
										<span class="other-info-content mb-3">
											{{contacts[0]?.address}}
										</span>
									</div>
									<div class="d-flex justify-content-center justify-content-md-start mb-1">
										<a :href="`tel:${contacts[0]?.phone}`" class="other-info-content text-decoration-none dark-blue-color">
											{{ $t('phone') }} : {{contacts[0]?.phone}}
										</a>
									</div>
									<div class="d-flex justify-content-center justify-content-md-start">
										<a :href="`mailto:${contacts[0]?.email}`" class="other-info-content text-decoration-none dark-blue-color">
											{{ $t('email') }} : {{contacts[0]?.email}}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- company values section -->
		<section class="company-values-section pb-5">
			<div class="container h-100 pb-3">
				<div class="w-100 text-center pt-4 pb-2">
                    <h4 class="section-title" v-html="$t('homepage.company-values-section.title')"></h4>
                </div>

				<div class="w-100 d-flex flex-wrap justify-content-between pt-4">
                    <div
						v-for="item in companyValues"
						:key="item.id"
						class="comapny-values-card-block mb-3"
                    >
                        <div class="p-4 rounded-4 bg-white card-shadow h-100">
                            <div class="company-value-image pb-3">
								<img :src="item?.primaryImage?.url" alt="" width="30">
							</div>
							<div class="company-value-title bold pb-2">{{ item.title }}</div>
							<div class="company-value-content" v-html="item.content"></div>
                        </div>
                    </div>
                </div>
			</div>
		</section>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { filterAttributeValues } from '@/helpers/functions'
import ContactForm from '@/components/ContactForm.vue'
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import 'hooper/dist/hooper.css';
import { BYTE_RANGE_URL } from '@/helpers/constants'

export default {
	components: {
		Hooper,
		Slide,
		HooperPagination,
		ContactForm
	},

	data () {
		return {
			showSliders: false,
			activeCategory: null,
			isFormSubmitted: false,
			categoriesTest: [
				{
					id: 1,
					title: 'title',
					content: 'something here just to fill the content of the categories card... ye they want more words...',
					image: require('@/assets/images/screw-wall-plug.png'),
					to: '/category/1'
				},
				{
					id: 2,
					title: 'title',
					content: 'something here just to fill the content of the categories card... ye they want more words...',
					image: require('@/assets/images/screw-wall-plug.png'),
					to: '/category/2'
				},
				{
					id: 3,
					title: 'title',
					content: 'something here just to fill the content of the categories card... ye they want more words...',
					image: require('@/assets/images/screw-wall-plug.png'),
					to: '/category/3'
				},
			],

			tabstest: [
				{
					id: 1,
					name: 'براغي خشبية'
				},
				{
					id: 2,
					name: 'براغي PVC'
				},
				{
					id: 3,
					name: 'براغي حديد'
				}
			],

			productsTest: [
				{
					id: 1,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 2,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 3,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 4,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 5,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 6,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 7,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 8,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 9,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 10,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 11,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 12,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 13,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 14,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 15,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 16,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 17,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 18,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 19,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 20,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				}
			],

			companyValuesTest: [
				{
					id: 1,
					image: require('@/assets/images/review.png'),
					title: 'العميل في قلب كل قرار',
					content: 'نعتبر رضا العميل أولوية مطلقة, و نسعى لحل أي مشكلة بسرعة وفعالية لضمان استمرارية العمل معنابثقة و راحة'
				},
				{
					id: 2,
					image: require('@/assets/images/review.png'),
					title: 'العميل في قلب كل قرار',
					content: 'نعتبر رضا العميل أولوية مطلقة, و نسعى لحل أي مشكلة بسرعة وفعالية لضمان استمرارية العمل معنابثقة و راحة'
				},
				{
					id: 3,
					image: require('@/assets/images/review.png'),
					title: 'العميل في قلب كل قرار',
					content: 'نعتبر رضا العميل أولوية مطلقة, و نسعى لحل أي مشكلة بسرعة وفعالية لضمان استمرارية العمل معنابثقة و راحة'
				},
				{
					id: 4,
					image: require('@/assets/images/review.png'),
					title: 'العميل في قلب كل قرار',
					content: 'نعتبر رضا العميل أولوية مطلقة, و نسعى لحل أي مشكلة بسرعة وفعالية لضمان استمرارية العمل معنابثقة و راحة'
				}
			],
			BYTE_RANGE_URL
		}
	},

	computed: {
		...mapState({
			sliders: state => state.sliders.sliders,
			about: state => state.about.about,
			categories: state => state.categories.categories,
			products: state => state.products.products,
			companyValues: state => state.companyValues.companyValues,
			contacts: state => state.contacts.contacts,
			albums: state => state.albums.albums,
			// videoId: state => state.albums.albums[0]?.video[0].id
		}),

		tabs () {
			return this.categories.map(c => ({
				id: c.id,
				name: c.name,
				slug: c.slug
			}))
		},

		currentProducts () {
			if (this.activeCategory) {
				// return this.products.filter(c => c.id === this.categories.find(e => e.id === this.activeCategory).id)
				return this.products.filter(c => c.categoriesIds[0] === this.activeCategory)
			} else {
				return []
			}
		}
	},

	methods: {
		downloadFile () {
			const link = document.createElement('a');
			link.href = '/albunyan-catalog.pdf';
			link.download = 'albunyan-catalog.pdf';
			link.click();
		},

		submitForm (form) {
			this.$store.dispatch('feedback/createFeedback', form).then(() => {
				this.isFormSubmitted = true
			}).catch(() => {
				this.isFormSubmitted = false
			})
		},

		filterAttributeValues
	},

	created () {
		this.$emit('loading', true)
		const promises = [];

		if (this.sliders.length === 0) {
			promises.push(this.$store.dispatch('sliders/fetchSliders'));
		}
		if (this.companyValues.length === 0) {
			promises.push(this.$store.dispatch('companyValues/fetchCompanyValues'));
		}
		if (this.products.length === 0) {
			promises.push(this.$store.dispatch('products/fetchAllProducts'));
		}
		if (this.albums.length === 0) {
			promises.push(this.$store.dispatch('albums/fetchAlbums'));
		}

		Promise.all(promises).then(() => {
			this.activeCategory = this.categories[0]?.id
			setTimeout(() => {
				this.showSliders = true;
			}, 500);
			this.$emit('loading', false)
		});
	}
}
</script>

<style lang="scss" scoped>
@import '../scss/vars.scss';

// major classes
.section-title {
	font-weight: 800;
	line-height: 1.65;
}

.section-title ::v-deep span {
	color: $secondary;
	font-weight: 900;
}

// header section
.header-section {
    background:
        linear-gradient(to top, rgba($primary,0.85) 1%, rgba($primary, 1) 65%),
        url('@/assets/images/architectural-blueprints.png') center -7%/cover no-repeat;
    height: 450px;

    @media (min-width: 1376px) {
        height: 525px
    }

	.slider-font-size {
		font-size: 26px;
	}
}

.content-block-top {
    height: 62%;
}
.content-block-bottom{
    height: 38%;

    .block-width {
        width: 70%;
        height: 100%;
        @media (max-width: 992px) {
            width: 100%;
        }

        .block-width-wrapper {
            width: 75%;
            @media (max-width: 992px) {
                width: 50%
            }
            @media (max-width: 768px) {
                width: 75%
            }
            @media (max-width: 375px) {
                width: 100%
            }

            .button-1 {
				text-decoration: none;
                margin-inline-start: 7px;
                margin-inline-end: 7px;
				&:hover {
					transform: translateY(-1px);
					box-shadow: none;
				}

                @media (min-width: 1367) {
                    margin-inline-start: 14px;
                }
            }
            .button-2 {
				text-decoration: none;
                margin-inline-end: 7px;
                margin-inline-start: 7px;
				&:hover {
					transform: translateY(-1px);
					box-shadow: none;
				}

                @media (min-width: 1367) {
                    margin-inline-end: 14px;
                }
            }
        }

    }
}

// about section
.about-section {
    // height: 350px;
    .about-content {
        padding-left: 120px;
        padding-right: 0;
        padding-bottom: 30px;
        padding-top: 50px;

        @media (max-width: 992px) {
            padding-left: 0;
            padding-right: 0;
            padding-top: 30px;
            padding-bottom: 50px;
        }

        // for other language
        [dir='ltr'] & {
            padding-right: 120px;
            padding-left: 0;

            @media (max-width: 992px) {
                padding-left: 0;
                padding-right: 0;
            }
        }

       .about-content-title ::v-deep span {
            color: $secondary;
            font-weight: 900;
        }
    }

    .about-image {
        display: block;

        @media (max-width: 992px) {
            display: flex;
            justify-content: center;
        }
        .image-class {
            width: 100%;

            @media (max-width: 992px) {
                width: 50%;
            }

            @media (max-width: 475px) {
                width: 75%;
            }
        }
    }
}

// categories section
.categories-section {
    // height: 350px;

    .categories-card-block {
        width: 32%;
		padding: 0 0 30px;
		margin-left: 14px;

		@media (max-width: 1200px) {
			margin-left: 12px;
		}
        @media (max-width: 992px) {
            width: 48%;
        }
		@media (max-width: 768px) {
			margin-left: 10px;
		}
		@media (max-width: 538px) {
			width: 46%;
			margin-left: 8px;
		}
		// @media (max-width: 425px) {
		// 	width: 96%;
		// 	margin: 0 auto;
		// }

		.category-router-link {
			transition: transform 0.15s ease, box-shadow 0.15s ease;
			&:hover {
				transform: translateY(-3px);
				box-shadow: -5px 2px 50px 3px #f0f0f0 ;
			}
		}

		// for other language
        [dir='ltr'] & {
			margin-left: 0px;
            margin-right: 14px;

            @media (max-width: 1200px) {
				margin-right: 12px;
			}

			@media (max-width: 768px) {
				margin-right: 10px;
			}
			@media (max-width: 538px) {
				width: 46%;
				margin-right: 8px;
			}
			@media (max-width: 425px) {
				width: 96%;
				margin: 0 auto;
			}
        }

		.categories-card-content {
			width: 65%;
			@media (max-width: 992px) {
				width: 100%
			}

			p {
				line-height: 1.35;
			}
		}
		.categories-card-image {
			width: 35%;
			@media (max-width: 992px) {
				width: 100%
			}
		}
    }

}

// products section
.products-section {
    // height: 300px;

	.product-card-block {
		@media (min-width: 1600px) {
			width: 15%;
		}

		width: 17%;
		margin: 0 16px;

		@media (max-width: 1200px) {
			margin: 0 14px;
		}

		@media (max-width: 992px) {
			width: 23%;
			margin: 0 6px;
		}

		@media (max-width: 768px) {
			width: 31%
		}

		@media (max-width: 568px) {
			width: 47%;
		}

		@media (max-width: 438px) {
			margin: 0 5px;
		}

		@media (max-width: 375px) {
			margin: 0 auto;
		}

		@media (max-width: 359px) {
			width: 94%;
		}

		.product-image {
			height: 125px;
		}

		.product-name {
			font-size: 14px;
		}

		.product-attributes {
			font-size: 13px;
		}

		.card-content-height {
			height: 87.5%
		}

		transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-3px);
		}
	}

	.product-card-eye {
		background-color: $primary;
		height: 30px;
		color: white;
	}

}

// contact section
.contact-section {
    // height: 575px;
	.card-widths-1 {
		width: 65%;
		@media (max-width: 992px) {
			width: 100%
		}

		.form-card-width {
			width: 92%;
			height: 92%;
			@media (max-width: 992px) {
				width: 100%;
				height: 100%;
			}
		}
	}
	.card-widths-2 {
		width: 45%;
		@media (max-width: 992px) {
			width: 100%
		}

		.contact-info-title {
			font-size: 20px;
		}
		.contact-info-content {
			font-size: 16px;
		}

		.info-titles {
			font-size: 14px;
			font-weight: 800;
		}

		.info-items-links {
			color: rgb(58, 65, 160);
			text-decoration: none;
			font-size: 13px;
		}

		.other-info-title {
			font-size: 16px;
			font-weight: 800;
		}

		.other-info-content {
			font-size: 14px;
			font-weight: 600;
		}

		.info-text-align {
			text-align: start;
			@media (max-width: 768px) {
				text-align: center;
			}
		}
	}
}

// company values section
.company-values-section {
    // height: 400px;
	.comapny-values-card-block {
		width: 23%;
		@media (max-width: 992px) {
			width: 32%;
		}

		@media (max-width: 768px) {
			width: 48%
		}

		@media (max-width: 475px) {
			width: 100%
		}

		.company-value-title {
			font-size: 15px;
		}

		.company-value-content {
			font-size: 14px;
			font-weight: 600;
		}
	}
}

.nav-link {
	color: rgb(58, 65, 160);
	font-weight: bold;
	border-radius: 0;
}
.nav-link.active {
	background-color: transparent;
	color: $secondary;
	border-bottom: 1px solid $secondary;
}

</style>

<style lang="scss">
.is-active {
    background-color: transparent;
}

.hooper-slide {
    background-color: transparent;
    padding: 20px;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    color: #fff;
    font-size: 30px;
    border-radius: 10px;
}
.hooper-slide {
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    height: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
}

/* Change pagination dots color */
.hooper-pagination {
  padding: 10px 0;
  width: 90%;
  display: flex !important;
  justify-content: flex-start !important; /* Force left alignment */
  margin-left: 0; /* Remove default margin */

  @media (max-width: 992px) {
	justify-content: center!important
  }
}
.hooper-indicator {
  background: transparent; /* Inactive dot color */
  border: 1px solid grey;
  width: 28px;
  height: 3px;
}
.hooper-indicator:hover {
	background-color: transparent;
}
.hooper-indicator.is-active {
  background: #FFF; /* Active dot color */
}

.nav-pills {
	@media (max-width: 475px) {
		padding: 0
	}
}
</style>

<style lang="scss">
	.v-html-content * {
		margin-bottom: 0px;
	}

	.v-html-card-header {
		@media (max-width: 425px) {
			font-size: 16px;
		}
	}

	.v-html-card-description {
		@media (max-width: 475px) {
			font-size: 14px;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	.content-elipse {
		font-size: 12px;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>